module.exports = __webpack_public_path__ + "img/vitality-money-Blue.5c782fc3.svg";